import * as React from 'react'
import { Wrapper, InputContainer, Input, Decoration } from './Styles'

interface Props {
  value: string
  children?: {
    precomponent?: React.ReactNode
    postcomponent?: React.ReactNode
  }
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  handleFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  handleClick?: (e: React.MouseEvent<HTMLInputElement>) => void
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

type PropsWithAttrs = Props & React.InputHTMLAttributes<HTMLInputElement>

const TextInput = React.forwardRef<HTMLInputElement, PropsWithAttrs>((props, ref) => {
  const {
    children,
    handleBlur,
    handleFocus,
    handleClick,
    handleChange,
    handleKeyDown,
    value,
    ...rest
  } = props

  return (
    <InputContainer>
      <Decoration>{children?.precomponent}</Decoration>
      <Input
        ref={ref}
        value={value}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onClick={handleClick}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete="new-password"
        type="text"
        {...rest}
      />
      <Wrapper />
      <Decoration>{children?.postcomponent}</Decoration>
    </InputContainer>
  )
})

export default React.memo(TextInput)
